import "core-js/modules/es6.array.find-index";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.to-string";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

/*
 * @Author: Jhonsem
 * @Date: 2019-03-19 12:11:30
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-03-19 12:12:34
 */
import * as constants from "./constants";
import { getUUid, filterBase64Pic } from "../utils/apiHelper";
import MD5 from "crypto-js/md5";
import HttpClient from "../http/index";
import { isJSON } from "@/utils/lodash";
import { sendMapEvent } from "@/utils/analytics";
import { clientError } from "@/api/utils/apiHelper";
import { toString } from "lodash";

var faceClientErrorEvent = function faceClientErrorEvent(key, result) {
  try {
    if (result.data && typeof result.data === "string" && result.data.includes("false")) {
      if (isJSON(result.data)) {
        var error = JSON.parse(result.data);
        sendMapEvent("face_" + key, {
          error_code: error.code ? toString(error.code) : "1001",
          error_message: error.message ? error.message : "null"
        });
      } else {
        sendMapEvent("face_" + key, {
          error_code: "1002",
          error_message: result.data
        });
      }
    } else {
      sendMapEvent("face_" + key, {
        error_code: "",
        error_message: toString(result)
      });
    }
  } catch (error) {}
};

var FaceClient =
/*#__PURE__*/
function () {
  function FaceClient() {
    _classCallCheck(this, FaceClient);
  }

  _createClass(FaceClient, [{
    key: "CommonRequestFactory",
    value: function CommonRequestFactory() {
      var req = {};
      req.headers = {};
      req.headers["User-Agent"] = constants.UA;
      req.headers["Content-Type"] = "application/json";
      req.data = {};
      req.data.timestamp = Math.floor(new Date().getTime() / 1000).toString();
      req.data.dtype = "i";
      req.data.deviceId = getUUid();
      return req;
    }
  }, {
    key: "signRequest",
    value: function signRequest(req) {
      var pairs = [];

      var _arr = _Object$keys(req.data);

      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];

        if (key === "pic") {
          continue;
        }

        pairs.push("".concat(key, "=").concat(req.data[key]));
      }

      pairs.push("secretKey=".concat(constants.SECRET_KEY));
      pairs.sort(); // console.log("pairs:", pairs);

      var str = pairs.join("&");
      req.data.sign = MD5(str).toString().toLowerCase(); // 请自行引入MD5库,小写
    }
    /**
     * 其他请求前的check请求 1,2,3
     * @param base64_photo  图片的base64都需要以/9j 开头，不要带data:image/jpeg;base64,
     */

  }, {
    key: "req_check",
    value: function req_check() {
      var _this = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var base64_photo = arguments.length > 1 ? arguments[1] : undefined;
      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  base64_photo = filterBase64Pic(base64_photo);
                  req = _this.CommonRequestFactory();
                  req.method = "POST";
                  req.path = constants.FACE_PRE_CHECK_PATH;
                  req.data.pic = base64_photo; // base64 图片

                  req.data.type = type;

                  _this.signRequest(req); //json headers set:


                  req.serializer = "json";
                  _context.next = 11;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_PRE_CHECK_PATH, req);

                case 11:
                  res = _context.sent;
                  faceClientErrorEvent("req_check", res);
                  resolve(res);
                  _context.next = 20;
                  break;

                case 16:
                  _context.prev = 16;
                  _context.t0 = _context["catch"](0);
                  clientError("req_check", _context.t0);
                  reject(_context.t0);

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 16]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * 变老相机
     * 需要先请求 req_check (type==3,base64_photo)
     * 返回的结果中带 key,ethnicity,sex ;
     * 然后再传入当前接口
     * @param age 50，70，90
     * @param key  例如：key:“054b6da2ef114b43ab60a19fc9b22f0a”
     * @param ethnicity ethnicity  ASIAN 来源于req_check的
     * @param sex sex 0=Male 1=Female
     * @param base64_photo
     */

  }, {
    key: "req_age",
    value: function req_age(age, key, ethnicity, sex, base64_photo) {
      var _this2 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  base64_photo = filterBase64Pic(base64_photo);
                  req = _this2.CommonRequestFactory();
                  req.method = "POST";
                  req.path = constants.FACE_AGE_PATH;
                  req.data.pic = base64_photo; // base64 图片

                  req.data.age = age.toString();
                  req.data.ethnicity = ethnicity;
                  req.data.key = key;
                  req.data.sex = sex;

                  _this2.signRequest(req); //json headers set:


                  req.serializer = "json";
                  _context2.next = 14;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_AGE_PATH, req);

                case 14:
                  res = _context2.sent;
                  faceClientErrorEvent("req_age", res); //打点

                  resolve(res);
                  _context2.next = 23;
                  break;

                case 19:
                  _context2.prev = 19;
                  _context2.t0 = _context2["catch"](0);
                  clientError("req_age", _context2.t0);
                  reject(_context2.t0);

                case 23:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 19]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
    /**
     *  未来宝贝
     * @param key key来源于req_check(1)的结果
     * @param ethnicity  ethnicity 0=Caucasian 1=MiddleEastern/NorthAfican 2=EastAsian 3=SoutheastAsian 4=SouthAsian 5=Hispanic 6=Latino 7=Black
     * @param sex sex 0=Boy 1=Girl 2=Either
     */

  }, {
    key: "req_future_baby",
    value: function req_future_baby(key, ethnicity, sex) {
      var _this3 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var areaList, sexList, area_num, sex_num, req, res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  areaList = ["Caucasian", "Middle eastern/North African", "East Asian", "Southeast Asian", "South Asian", "Hispanic", "Latino", "Black"];
                  sexList = ["Boy", "Girl", "Either"];
                  area_num = areaList.findIndex(function (v) {
                    return v.indexOf(ethnicity) > -1;
                  });
                  sex_num = sexList.indexOf(sex); // console.log(area_num, sex_num);

                  req = _this3.CommonRequestFactory();
                  req.method = "POST";
                  req.path = constants.FACE_BABY_PATH;
                  req.data.ethnicity = area_num;
                  req.data.key = key;
                  req.data.sex = sex_num;

                  _this3.signRequest(req); //json headers set:


                  req.serializer = "json";
                  _context3.next = 15;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_BABY_PATH, req);

                case 15:
                  res = _context3.sent;
                  faceClientErrorEvent("req_future_baby", res); //打点

                  resolve(res);
                  _context3.next = 24;
                  break;

                case 20:
                  _context3.prev = 20;
                  _context3.t0 = _context3["catch"](0);
                  clientError("req_future_baby", _context3.t0);
                  reject(_context3.t0);

                case 24:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 20]]);
        }));

        return function (_x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
    /**
     * 未来的职业
     * @param key  key来源于req_check(2)的结果
     * @param birthday  格式 "MM-dd"
     */

  }, {
    key: "req_future_profession",
    value: function req_future_profession(key, birthday) {
      var _this4 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref4 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  req = _this4.CommonRequestFactory();
                  req.method = "POST";
                  req.path = constants.FACE_FUTURE_PATH;
                  req.data.key = key;
                  req.data.birthday = birthday;

                  _this4.signRequest(req); //json headers set:


                  req.serializer = "json";
                  _context4.next = 10;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_FUTURE_PATH, req);

                case 10:
                  res = _context4.sent;
                  faceClientErrorEvent("req_future_profession", res); //打点

                  resolve(res);
                  _context4.next = 18;
                  break;

                case 15:
                  _context4.prev = 15;
                  _context4.t0 = _context4["catch"](0);
                  reject(_context4.t0);

                case 18:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 15]]);
        }));

        return function (_x7, _x8) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
    /**
     * 种族分析 不需要预先请求check
     * @param base64_photo
     */

  }, {
    key: "req_ethnicity",
    value: function req_ethnicity(base64_photo) {
      var _this5 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  base64_photo = filterBase64Pic(base64_photo);
                  req = _this5.CommonRequestFactory();
                  console.log("req =====>", req);
                  req.method = "POST";
                  req.path = constants.FACE_ETHNICITY_PATH;
                  req.data.pic = base64_photo; // base64 图片

                  _this5.signRequest(req); //json headers set:


                  req.serializer = "json";
                  _context5.next = 11;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_ETHNICITY_PATH, req);

                case 11:
                  res = _context5.sent;
                  faceClientErrorEvent("req_ethnicity", res); //打点

                  resolve(res);
                  _context5.next = 20;
                  break;

                case 16:
                  _context5.prev = 16;
                  _context5.t0 = _context5["catch"](0);
                  clientError("req_ethnicity", _context5.t0);
                  reject(_context5.t0);

                case 20:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[0, 16]]);
        }));

        return function (_x9, _x10) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
    /**
     * 比美 ，不需要预先请求
     * 照片需要合并成一张，上下摆放
     * @param base64_photo
     */

  }, {
    key: "req_beauty_race",
    value: function req_beauty_race(base64_photo) {
      var _this6 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref6 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.prev = 0;
                  base64_photo = filterBase64Pic(base64_photo);
                  req = _this6.CommonRequestFactory();
                  req.method = "POST";
                  req.path = constants.FACE_BEAUTY_PATH;
                  req.data.pic = base64_photo; // base64 图片

                  _this6.signRequest(req); //json headers set:


                  req.serializer = "json";
                  _context6.next = 10;
                  return HttpClient.post(constants.BASE_URL + constants.FACE_BEAUTY_PATH, req);

                case 10:
                  res = _context6.sent;
                  faceClientErrorEvent("req_beauty_race", res); //打点

                  resolve(res);
                  _context6.next = 19;
                  break;

                case 15:
                  _context6.prev = 15;
                  _context6.t0 = _context6["catch"](0);
                  clientError("req_beauty_race", _context6.t0);
                  reject(_context6.t0);

                case 19:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, null, [[0, 15]]);
        }));

        return function (_x11, _x12) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }]);

  return FaceClient;
}();

export default new FaceClient();